/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import {
  IDeviceInitialState,
  IEvent,
  IDeviceAction,
  ISelectedTemplate,
  IRadioNodeCellConfig,
  IRnLteCellConfig,
  IdeviceCounts,
  IdrawerCounts,
  ISiteOfflineDetails,
  NoteData,
  ILabelData,
  ILabelDeviceState
} from "./types";
import { IDusNodeDataGridRow, IFullDeviceDetails, INrCell, IRadioNodesDataGridRow } from "../deviceConfig/types";
import { IKeyValueArray } from "../../../components/Administrations/types";


export const setSelectedDeviceAction = (state: IDeviceInitialState, action: PayloadAction<IFullDeviceDetails>) => {
  state.selectedDevice = { ...action.payload };
};

export const setDeviceDataCountAction = (state: IDeviceInitialState, action: PayloadAction<IdeviceCounts>) => {
  state.deviceDataCount = { ...action.payload };
};

export const setDrawerCountsAction = (state: IDeviceInitialState, action: PayloadAction<IdrawerCounts>) => {
  state.drawerCounts = { ...action.payload };
};

export const setSelectedDeviceAlarmsAction = (state: IDeviceInitialState, action: PayloadAction<IEvent[]>) => {
  state.selectedDeviceAlarms = action.payload;
};

export const setNoOfSelectedRowAction = (state: IDeviceInitialState, action: PayloadAction<IKeyValueArray>) => {
  state.noOfSelectedRow = { ...action.payload };
};

export const setDeviceActionAction = (state: IDeviceInitialState, action: PayloadAction<IDeviceAction>) => {
  state.deviceAction = { ...action.payload };
};

export const selectedTempalateAction = (state: IDeviceInitialState, action: PayloadAction<ISelectedTemplate>) => {
  state.selectedTemplate = { ...action.payload };
};

export const setSelectedTypeAction = (state: IDeviceInitialState | any, action: PayloadAction<string>) => {
  state.selectedType = action.payload;
};

export const selectedGlobalTempalateAction = (state: IDeviceInitialState, action: PayloadAction<ISelectedTemplate>) => {
  state.globalTemplate = { ...action.payload };
};

export const setSelectedDeviceAlarmCountAction = (state: IDeviceInitialState, action: PayloadAction<number>) => {
  state.selectedDeviceAlarmCount = action.payload;
};

export const setOpenDeviceDrawerAction = (state: IDeviceInitialState, action: PayloadAction<boolean>) => {
  state.isOpenDeviceDrawer = action.payload;
};

export const setSelecteRnCellConfigAction = (state: IDeviceInitialState, action: PayloadAction<IRadioNodeCellConfig>) => {
  state.selectedRnCellConfig = action.payload;
};

export const setRadioFirstLteCellAction = (state: IDeviceInitialState, action: PayloadAction<IRnLteCellConfig>) => {
  state.radioFirstLteCellconfig = action.payload;
};

export const setRadioSecondLteCellAction = (state: IDeviceInitialState, action: PayloadAction<IRnLteCellConfig>) => {
  state.radioSecondLteCellconfig = action.payload;
};

export const setSelectedRadioAction = (state: IDeviceInitialState, action: PayloadAction<IRadioNodesDataGridRow>) => {
  state.selectedRadioNode = action.payload;
};

export const setOpenRnDrawerAction = (state: IDeviceInitialState, action: PayloadAction<boolean>) => {
  state.isOpenRnDrawer = action.payload;
};

export const setSelectedDuAction = (state: IDeviceInitialState, action: PayloadAction<IDusNodeDataGridRow>) => {
  state.selectedDuNode = action.payload;
};

export const setRadioFirstNrCellAction = (state: IDeviceInitialState, action: PayloadAction<INrCell>) => {
  state.radioFirstNrCellconfig = action.payload;
};

export const setRadioSecondNrCellAction = (state: IDeviceInitialState, action: PayloadAction<INrCell>) => {
  state.radioSecondNrCellconfig = action.payload;
};

export const setOpenDuDrawerAction = (state: IDeviceInitialState, action: PayloadAction<boolean>) => {
  state.isOpenDuDrawer = action.payload;
};

export const setOpenRnCUDrawerAction = (state: IDeviceInitialState, action: PayloadAction<boolean>) => {
  state.isOpenRnCuDrawer = action.payload;
};

export const setOpenLteDrawerAction = (state: IDeviceInitialState, action: PayloadAction<boolean>) => {
  state.isOpenLteDrawer = action.payload;
};

export const setOpenNrDrawerAction = (state: IDeviceInitialState, action: PayloadAction<boolean>) => {
  state.isOpenNrDrawer = action.payload;
};

export const setOpenCellDrawerAction = (state: IDeviceInitialState, action: PayloadAction<boolean>) => {
  state.isOpenCellDrawer = action.payload;
};

export const setCellSavedAction = (state: IDeviceInitialState, action: PayloadAction<boolean>) => {
  state.isCellSaved = action.payload;
};


export const setLabelListAction = (state: IDeviceInitialState, action: PayloadAction<ILabelData[]>) => {
 
    const labelList = action.payload?.map((item: ILabelData) => ({ text: item?.text, value: item?.value ?? item.text, deviceCount: item.deviceCount })) || [];
    state.labelList = labelList;
  
};

export const setNotifyLabelAction = (state: IDeviceInitialState, action: PayloadAction<ILabelData>) => {
  state.selectedLabel = { ...state.selectedLabel, ...action.payload };
}

export const setSelectedDeviceIdAction = (state: IDeviceInitialState, action: PayloadAction<string>) => {
  state.selectedDeviceId = action.payload;
}

export const setSiteOfflineAction = (state: IDeviceInitialState | any, action: PayloadAction<ISiteOfflineDetails>) => {
  if (Object.keys(action.payload).length > 0) {
    state.initialSiteDetails = { ...state.initialSiteDetails, ...action.payload };
  } else {
    state.initialSiteDetails.group = "";
    state.initialSiteDetails.siteType = "";
    state.initialSiteDetails.siteName = "";
    state.initialSiteDetails.serialNumber = "";
    state.initialSiteDetails.siteLabel = "";
    state.initialSiteDetails.market = "";
    state.initialSiteDetails.version = "";
    state.initialSiteDetails.eNBId = "";
    state.initialSiteDetails.state = "";
    state.initialSiteDetails.latitude = "";
    state.initialSiteDetails.longitude = "";
  }
}

export const setSelectedNoteAction = (state: NoteData | any, action: PayloadAction<number>) => {
  state.selectedNote = action.payload;
}

export const setSelectedGeoRegionsAction = (
  state: IDeviceInitialState,
  action: PayloadAction<string[]>
) => {
  state.selectedGeoRegions = action.payload;
};

